import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './CarShowcase.css';
import { CARS } from '../data/cars';
import { FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import CarDetailsOverlay from './CarDetailsOverlay';

function CarShowcase() {
  const navigate = useNavigate();
  const [selectedCar, setSelectedCar] = useState(null);

  const handleQuoteClick = (carId) => {
    navigate('/quote', { state: { selectedCar: carId } });
  };

  const handleDetailsClick = (car) => {
    setSelectedCar(car);
  };

  const handleCloseOverlay = () => {
    setSelectedCar(null);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  };

  return (
    <div className="car-showcase-section">
      <div className="car-showcase-container">
        <div className="car-showcase-header">
          <h2 className="car-showcase-title">Notre Flotte</h2>
          <p className="car-showcase-subtitle">
            Découvrez notre sélection de véhicules haut de gamme pour tous vos déplacements
          </p>
        </div>

        <Slider {...settings} className="car-slider">
          {CARS.map((car, index) => (
            <div key={index} className="car-card-wrapper">
              <div className="car-card">
                <div className="card-header">
                  <span>{car.model}</span>
                </div>
                <div className="card-image">
                  <img src={car.image} alt={car.model} />
                </div>
                <div className="card-footer">
                  <div className="info">
                    <p><FaUser /> {car.seats} Sièges</p>
                    <span className="separator">|</span>
                    <p className="price-info">CHF {car.pricePerKm.toFixed(2)}/km</p>
                  </div>
                  <div className="buttons">
                    <button 
                      className="details-button" 
                      onClick={() => handleDetailsClick(car)}
                    >
                      Détails
                    </button>
                    <button 
                      className="quote-button" 
                      onClick={() => handleQuoteClick(car.id)}
                    >
                      Devis
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      {selectedCar && (
        <CarDetailsOverlay 
          car={selectedCar} 
          onClose={handleCloseOverlay}
        />
      )}
    </div>
  );
}

export default CarShowcase;